// Display Fields
const image = 'image';
const richText = 'richText';

// Data Fields
const text = 'text';
const textarea = 'textarea';
const number = 'number';
const dropdown = 'dropdown';
const multiSelect = 'multiSelect';
const date = 'date';
const signature = 'signature';
const table = 'table';
const chart = 'chart';
const block = 'block';

const types = {
  image,
  richText,
  text,
  textarea,
  number,
  date,
  signature,
  table,
  chart,
  multiSelect,
  dropdown,
  block,
};

types.all = Object.keys(types);

export default types;
